"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDistributorFlashOrder = void 0;
const routes_1 = require("../../routes");
const getDistributorFlashOrder = (client) => async (params) => {
    const url = routes_1.ENDPOINTS.GET_PARTNER_FLASH_ORDER.applyParams({
        distributorId: params.distributorId,
        flashOrderId: params.flashOrderId,
    });
    const response = await client.get(url, {
        headers: {
            'x-beneficiary-id': params.beneficiaryId,
            ...(params.locale ? { 'idf-locale': params.locale } : {}),
        },
    });
    return response.data;
};
exports.getDistributorFlashOrder = getDistributorFlashOrder;
